module.exports = __webpack_public_path__ + "static/media/img24.f81cc09e.jpg";